import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, message, Modal, Slider, Spin, Tooltip } from 'antd';
import Icon from '@ant-design/icons';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import { ReactComponent as CheckIcon } from '../../assets/icons/check-icon.svg';
import { ReactComponent as CrossIcon } from '../../assets/icons/cross-icon.svg';
import SideTitleInfo from '../SideTitleInfo/SideTitleInfo';
import { planDetail } from '../../constant';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import PriceSummary from './Model/PriceSummaryModel';
// import closeIcon from '../../assets/icons/fontisto_close.svg';
import { ReactComponent as twinkle_icon } from '../../assets/icons/Sprinkle.svg';
import { GlobalContext } from '../../Context';
import { clearAuth } from '../../utils/auth';
import PlanCancellationModal from './Model/PlanCancellationModal';
import DowngradePlanModal from '../Model/DowngradePlanModel';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!);

const FeatureItem = ({ text, active }: { text: string; active?: boolean }) => (
  <div style={{
    display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px',
    color: active ? '#444' : '#bbb', fontSize: '13px',
    textDecoration: active ? 'none' : 'line-through'
  }}>
    <span style={{
      color: active ? '#25a07b' : '#ccc',
      fontWeight: 'bold', fontSize: '14px'
    }}>
      {active ? '✓' : '×'}
    </span>
    {text}
  </div>
);

const PlanBills = ({ isOnboarding }: { isOnboarding?: boolean }) => {
  const [planChoose, setPlanChoose] = useState('yearly');
  const userId = localStorage.getItem('userId');
  const [loading, setLoading]: any = useState({});
  const [activePlanId, setActivePlanId] = useState('');
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const [planDetails, setPlanDetails] = useState<any>();
  const [downgradePlanName, setDowngradePlanName] = useState<any>('');
  const planRef: any = useRef(null);
  const [plans, setPlans] = useState([]);
  const [blogPrice, setBlogPrice] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDowngradeModelVisible, setIsDowngradeModelVisible] = useState(false);
  const [downPriceId, setDownPriceId] = useState();
  const [downPriceName, setDownPriceName] = useState();
  const [downPlan, setDownPlan] = useState();
  const [addOnDetails, setAddOnDetails] = useState([
    { name: 'Blog Count', value: 0, price: 0 }
  ]);
  const AUDIT_UNIT_PRICE = 0.99;
  const [auditQty, setAuditQty] = useState(0);
  const [auditPrice, setAuditPrice] = useState(0);
  const AEO_UNIT_PRICE = 0.99;
  const [aeoQty, setAeoQty] = useState(0);
  const [aeoPrice, setAeoPrice] = useState(0);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const [selectedPlan, setSelectedPlan] = useState<any>(null);
  const [checkoutLoading, setCheckoutLoading] = useState(false);

  const [userDetails, setUserDetails] = useState({
    username: '',
    email: ''
  });

  const handleLogout = () => {
    clearAuth();
    navigate('/login');
  };

  const createCheckoutSession = async (plan: any) => {
    setCheckoutLoading(true);
    setClientSecret(null);
    setSelectedPlan(plan);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/trial/checkout-session`,
        { userId, priceId: plan.priceID },
        { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      );
      if (res.data?.clientSecret) {
        setClientSecret(res.data.clientSecret);
      } else {
        message.error('Could not initialize checkout');
      }
    } catch (error: any) {
      message.error(error.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setCheckoutLoading(false);
    }
  };

  const models = ['gemini-3.5-flash', 'gemini-3.1-pro', 'gpt-5', 'gpt-5.4-mini', 'claude-sonnet-5'];

  const modelNames: { [key: string]: string } = {
    'gemini-3.5-flash': 'Gemini-3.5 Flash',
    'gemini-3.1-pro': 'Gemini-3.1 Pro',
    'gpt-5': 'GPT-5',
    'gpt-5.4-mini': 'GPT-5.4 Mini',
    'claude-sonnet-5': 'Claude Sonnet 5'
  };

  const { usage, setUsage }: any = useContext(GlobalContext);

  const blogMarks = {
    0: {
      style: {
        color: blogPrice === 0 ? '#ff7c02' : 'gray',
        fontWeight: blogPrice === 0 ? 'bold' : 'normal',
        fontSize: blogPrice === 0 ? '20px' : '14px'
      },
      label: '0'
    },
    33.33: {
      style: {
        color: blogPrice === 5 ? '#ff7c02' : 'gray',
        fontWeight: blogPrice === 5 ? 'bold' : 'normal',
        fontSize: blogPrice === 5 ? '20px' : '14px'
      },
      label: '5'
    },
    66.67: {
      style: {
        color: blogPrice === 10 ? '#ff7c02' : 'gray',
        fontWeight: blogPrice === 10 ? 'bold' : 'normal',
        fontSize: blogPrice === 10 ? '20px' : '14px'
      },
      label: '10'
    },
    100: {
      style: {
        color: blogPrice === 15 ? '#ff7c02' : 'gray',
        fontWeight: blogPrice === 15 ? 'bold' : 'normal',
        fontSize: blogPrice === 15 ? '20px' : '14px'
      },
      label: '15'
    }
  };


  /// check if user already has default payment method set
  const checkUserPaymentMethod = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/has-payment-method?userId=${userId}`,

        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
          }
        }
      );

      return response.data?.hasPaymentMethod;
    } catch (error) {
      console.log(error);
    }
  };

  const getUsage = async () => {
    const usage = await axios.get(`${process.env.REACT_APP_SERVER_URL}/usage?userId=${userId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
      }
    });
    setUsage({
      usedBlog: usage.data?.blogCreated || 0,
      totalBlog: usage.data?.blogLimit || 0,
      usedAudit: usage.data?.blogAuditUsed || 0,
      totalAudit: usage.data?.blogAuditLimit || 0
    });
  };

  const purchaseAddOn = async () => {
    // Block trial users from purchasing add-ons
    if (planDetails?.isTrial) {
      message.warning({
        content: 'Add-ons are not available during your free trial. Please upgrade to a paid plan to purchase add-ons.',
        key: 'addon-trial-block'
      });
      return;
    }

    if (addOnDetails[0].value === 0) {
      message.error({ content: 'Please select atleast one add-on to purchase.', key: 'addon-validation' });
      return;
    }

    const hasPaymentMethod = await checkUserPaymentMethod();
    if (hasPaymentMethod) {
      navigate(
        `/plan-checkout?source=add-on&blog=${addOnDetails[0].value}&addCard=false`
      );
    } else {
      navigate(
        `/plan-checkout?source=add-on&blog=${addOnDetails[0].value}&addCard=true`
      );
    }
  };

  // Razorpay checkout when buying plan first times
  const openRazorpayCheckout = (subscriptionId: string) => {
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      subscription_id: subscriptionId,
      handler: function (response: any) {
        axios
          .post(
            `${process.env.REACT_APP_SERVER_URL}/payment-verification`,
            {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_subscription_id: response.razorpay_subscription_id,
              razorpay_signature: response.razorpay_signature,
              userId
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`
              }
            }
          )
          .then((res) => {
            message.success('Payment successful!');
            // Redirect to success page or update UI accordingly
          })
          .catch((error) => {
            console.log(error);
            message.error('Payment verification failed');
          });
      }
    };

    const razorpay = new window.Razorpay(options);
    razorpay.open();
  };

  // Fetch plan details


  const auditMarks = {
    0: {
      style: { color: auditQty === 0 ? '#ff7c02' : 'gray', fontWeight: auditQty === 0 ? 'bold' : 'normal', fontSize: auditQty === 0 ? '20px' : '14px' },
      label: '0'
    },
    33.33: {
      style: { color: auditQty === 5 ? '#ff7c02' : 'gray', fontWeight: auditQty === 5 ? 'bold' : 'normal', fontSize: auditQty === 5 ? '20px' : '14px' },
      label: '5'
    },
    66.67: {
      style: { color: auditQty === 10 ? '#ff7c02' : 'gray', fontWeight: auditQty === 10 ? 'bold' : 'normal', fontSize: auditQty === 10 ? '20px' : '14px' },
      label: '10'
    },
    100: {
      style: { color: auditQty === 20 ? '#ff7c02' : 'gray', fontWeight: auditQty === 20 ? 'bold' : 'normal', fontSize: auditQty === 20 ? '20px' : '14px' },
      label: '20'
    }
  };

  const setAuditAddOn = (value: any) => {
    const mapped: { [key: number]: number } = { 0: 0, 33.33: 5, 66.67: 10, 100: 20 };
    const qty = mapped[value] ?? 0;
    setAuditQty(qty);
    setAuditPrice(Number((qty * AUDIT_UNIT_PRICE).toFixed(2)));
  };

  const purchaseAuditAddOn = async () => {
    if (planDetails?.isTrial) {
      message.warning({
        content: 'Add-ons are not available during your free trial. Please upgrade to a paid plan to purchase add-ons.',
        key: 'audit-addon-trial-block'
      });
      return;
    }
    if (auditQty === 0) {
      message.error({ content: 'Please select a Blog Auditor credit quantity.', key: 'audit-addon-validation' });
      return;
    }
    const hasPaymentMethod = await checkUserPaymentMethod();
    navigate(`/plan-checkout?source=blog-audit-addon&blogAudit=${auditQty}&addCard=${hasPaymentMethod ? 'false' : 'true'}`);
  };

  const aeoMarks = {
    0: { style: { color: aeoQty === 0 ? '#ff7c02' : 'gray', fontWeight: aeoQty === 0 ? 'bold' : 'normal', fontSize: aeoQty === 0 ? '20px' : '14px' }, label: '0' },
    33.33: { style: { color: aeoQty === 5 ? '#ff7c02' : 'gray', fontWeight: aeoQty === 5 ? 'bold' : 'normal', fontSize: aeoQty === 5 ? '20px' : '14px' }, label: '5' },
    66.67: { style: { color: aeoQty === 10 ? '#ff7c02' : 'gray', fontWeight: aeoQty === 10 ? 'bold' : 'normal', fontSize: aeoQty === 10 ? '20px' : '14px' }, label: '10' },
    100: { style: { color: aeoQty === 20 ? '#ff7c02' : 'gray', fontWeight: aeoQty === 20 ? 'bold' : 'normal', fontSize: aeoQty === 20 ? '20px' : '14px' }, label: '20' }
  };

  const setAeoAddOn = (value: any) => {
    const mapped: { [key: number]: number } = { 0: 0, 33.33: 5, 66.67: 10, 100: 20 };
    const qty = mapped[value] ?? 0;
    setAeoQty(qty);
    setAeoPrice(Number((qty * AEO_UNIT_PRICE).toFixed(2)));
  };

  const purchaseAeoAddOn = async () => {
    if (planDetails?.isTrial) {
      message.warning({ content: 'Add-ons are not available during your free trial.', key: 'aeo-addon-trial-block' });
      return;
    }
    if (aeoQty === 0) {
      message.error({ content: 'Please select an AEO/GEO Scan credit quantity.', key: 'aeo-addon-validation' });
      return;
    }
    const hasPaymentMethod = await checkUserPaymentMethod();
    navigate(`/plan-checkout?source=aeo-scan-addon&aeoScan=${aeoQty}&addCard=${hasPaymentMethod ? 'false' : 'true'}`);
  };


  const addOnBlogCount = (value: any) => {
    const mappedValues: { [key: number]: number } = {
      0: 0,
      33.33: 5,
      66.67: 10,
      100: 15
    };

    const finalValue = mappedValues[value] ?? 0; // Default to 0 if the value doesn't exist
    setBlogPrice(finalValue * Number(process.env.REACT_APP_SINGLE_BLOG_COUNT_PRICE));
    setTotalPrice(finalValue * Number(process.env.REACT_APP_SINGLE_BLOG_COUNT_PRICE));
    setAddOnDetails((prevDetails) =>
      prevDetails.map((detail) =>
        detail.name === 'Blog Count'
          ? {
            ...detail,
            value: finalValue,
            price: finalValue * Number(process.env.REACT_APP_SINGLE_BLOG_COUNT_PRICE)
          }
          : detail
      )
    );
  };

  // Fetch user details from backend
  const fetchUserDetails = async () => {
    axios
      .get(`${process.env.REACT_APP_SERVER_URL}/getuser?userId=${userId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      })
      .then((res) => {
        setUserDetails({
          username: res.data.name,
          email: res.data.email
        });
      })
      .catch((err) => {
        console.error('Error fetching user details:', err);
      });
  };

  const handleCancelPlan = (reason: string, feedback: string) => {
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/cancel-subscription`, {
        userId,
        cancelReason: {
          comment: feedback,
          feedback: reason
        }
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      })
      .then((res) => {
        message.success({ content: 'Plan cancelled successfully', key: 'canceled-success' });
        setShowCancelModal(false);
        // Refresh plan details
        window.location.reload();
      })
      .catch((error) => {
        // Fallback for GET request if POST is not supported yet
        axios.get(`${process.env.REACT_APP_SERVER_URL}/cancel-subscription?userId=${userId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
          }
        }).then(() => {
          message.success({ content: 'Plan cancelled successfully', key: 'canceled-success' });
          setShowCancelModal(false);
          window.location.reload();
        }).catch((err) => {
          message.error({
            content: 'Unable to cancel plan. Please, try again later.',
            key: 'unable-to-fetch-plan'
          });
        });
      });
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_SERVER_URL}/plan-details?userId=${userId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      })
      .then((res) => {
        setPlanDetails(res.data);
        setActivePlanId(res.data.planId);
        setDowngradePlanName(res.data?.downgradePlan);
        if (res.data?.billingType === 'month') {
          setPlanChoose('monthly');
        } else if (res.data?.billingType === 'year') {
          setPlanChoose('yearly');
        }
      })
      .catch((err) => {
        console.log(err);
        message.error({
          content: 'Unable to fetch plan details. Please, try again later.',
          key: 'unable-to-fetch-plan'
        });
      });

    axios
      .get(`${process.env.REACT_APP_SERVER_URL}/plans`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      })
      .then((res) => {
        setPlans(res.data);
      })
      .catch((err) => {
        console.log(err);
        message.error({
          content: 'Unable to fetch plan details. Please, try again later.',
          key: 'unable-to-fetch-plan'
        });
      });

    /// update the user usage too on load
    getUsage();
    fetchUserDetails();
  }, []);

  useEffect(() => {
    setActiveIndex(plans.findIndex((item: any) => item.priceID == activePlanId));
  }, [plans, activePlanId]);

  // Auto-init embedded checkout with Pro plan (or first plan) on onboarding load
  useEffect(() => {
    if (!isOnboarding || (plans as any[]).length === 0 || clientSecret || checkoutLoading) return;
    const proPlan: any = (plans as any[]).find((p: any) => p.name === 'Pro') || plans[0];
    if (proPlan) createCheckoutSession(proPlan);
  }, [plans, isOnboarding]);

  function generatePriceId(plan: any, res: any) {
    const planData = res.data.find((p: any) => p.name.toLowerCase() === plan.toLowerCase());

    if (planData) {
      return planData.priceID;
    } else {
      return null; // Return null if plan name is not found
    }
  }

  // Filter plans for tab change
  const filteredPlans = planDetail.filter((item) => (item.time ? item.time === planChoose : true));

  const gotoPlans = () => {
    let x = document.querySelector('.main-content');
    const element = document.getElementById('plan-div');
    if (!element || !x) return;
    console.log(element, element?.offsetTop, x);
    x.scroll({
      top: element.offsetTop + 20,
      behavior: 'smooth'
    });
  };

  // Onboarding: single-page split layout — plan cards left, embedded checkout right
  if (isOnboarding) {
    return (
      <div className="planbills-wrapper onboarding onboarding-page" style={{
        minHeight: '100vh',
        background: '#fafafa',
        padding: '60px 24px'
      }}>
        <div className="onboarding-split-layout" style={{
          width: '100%',
          maxWidth: '1200px',
          margin: '0 auto',
          background: '#fff',
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'flex-start',
          overflow: 'clip',
          border: '1px solid #e2e4e8',
        }}>
          {/* LEFT: plan selection — scrolls with page */}
          <div className="onboarding-left-panel" style={{ flex: '1', padding: '40px', borderRight: '1px solid #e2e4e8', background: '#fcfcfc' }}>
            <div className="onboarding-plan-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
              <div>
                <h1 style={{ fontSize: '24px', fontWeight: 700, margin: '0 0 4px', color: '#1a1a1a' }}>Start Your 7-Day Free Trial</h1>
                <p style={{ color: '#666', margin: 0, fontSize: '14px' }}>No charge today · Cancel anytime</p>
              </div>
              <Button size='middle' onClick={handleLogout} className="sign-out-btn">Sign Out</Button>
            </div>

            <div style={{
              marginBottom: '32px',
              fontSize: '13px',
              color: '#ff7c02',
              textAlign: 'center',
              padding: '12px',
              background: 'rgba(255, 124, 2, 0.08)',
              borderRadius: '8px',
              border: '1px solid rgba(255, 124, 2, 0.2)',
              fontWeight: 500
            }}>
              ✨ 5 blog credits included · No charge until trial ends
            </div>

            <div className='plan-details-container' style={{ border: 'none', padding: 0, background: 'transparent' }}>
              <div className='plans-content-wrapper' style={{ background: 'transparent', marginBottom: 0 }}>
                <div className="plans-wrapper" style={{ display: 'flex', flexDirection: 'column', gap: '20px', margin: 0 }}>
                  {(plans as any[]).map((item: any, index: number) => {
                    const isSelected = selectedPlan?.priceID === item.priceID;
                    const isActive = isSelected || (!selectedPlan && item.name === 'Pro');

                    return (
                      <div key={index} className="plan-item" style={{ padding: 0, flex: 'none', width: '100%' }}>
                        <div
                          className={`content-wrapper ${isActive ? 'active' : ''}`}
                          onClick={() => { if (!isSelected && !checkoutLoading) createCheckoutSession(item); }}
                          style={{ cursor: 'pointer', minHeight: 'auto' }}
                        >
                          {item?.name === 'Pro' && (
                            <div className={`popular ${isActive ? 'active' : ''}`}>
                              <span role="img" aria-label="popular">🔥</span> Most Popular
                            </div>
                          )}
                          <div className={`plan-header ${isActive ? 'active' : ''}`}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                              <div className={`plan-title ${isActive ? 'active' : ''}`}>{item?.name}</div>
                              {isActive && (
                                <span style={{
                                  fontSize: '11px', fontWeight: 700,
                                  background: 'rgba(255,255,255,0.25)',
                                  color: '#fff', padding: '2px 8px',
                                  borderRadius: '12px', border: '1px solid rgba(255,255,255,0.4)'
                                }}>✓ Selected</span>
                              )}
                            </div>
                            <div className={`plan-price ${isActive ? 'active' : ''}`}>
                              <div className={`price ${isActive ? 'active' : ''}`}>
                                ${item?.price}
                                <span className='billed'>&nbsp; / &nbsp; mo</span>
                              </div>
                            </div>
                          </div>

                          <div className={`plan-content ${isActive ? 'active' : ''}`}>
                            <span className={`title ${isActive ? 'active' : ''}`}>LLM Models</span>
                            <ul>
                              {models?.map((cont: string) => (
                                item?.llmModels?.includes(cont) ? (
                                  <li key={cont}><Icon component={CheckIcon} /> {modelNames[cont] || cont}</li>
                                ) : (
                                  <li key={cont}><Icon component={CrossIcon} /> {modelNames[cont] || cont}</li>
                                )
                              ))}
                            </ul>
                          </div>

                          <div className={`plan-content ${isActive ? 'active' : ''}`}>
                            <span className={`title ${isActive ? 'active' : ''}`}>What's included?</span>
                            <ul>
                              <li className={isActive ? 'active' : ''}><Icon component={item?.blogCount ? CheckIcon : CrossIcon} /> {item.blogCount} Blog Generations / mo</li>
                              <li className={isActive ? 'active' : ''}><Icon component={item?.blogAuditCount ? CheckIcon : CrossIcon} /> {item?.blogAuditCount ?? item?.blogCount} Blog Auditor Credits / mo</li>
                              <li className={isActive ? 'active' : ''}><Icon component={item?.aeoScanCount ? CheckIcon : CrossIcon} /> {item?.aeoScanCount ?? item?.blogCount} AEO Scan Credits / mo</li>
                              <li className={isActive ? 'active' : ''}><Icon component={item?.fileCount ? CheckIcon : CrossIcon} /> {item.fileCount} Files per Blog</li>
                              <li className={isActive ? 'active' : ''}><Icon component={item?.keywordResearch ? CheckIcon : CrossIcon} /> Key Word Research</li>
                              <li className={isActive ? 'active' : ''}><Icon component={item?.aiImageGeneration ? CheckIcon : CrossIcon} /> AI Image Generation</li>
                              <li className={isActive ? 'active' : ''}><Icon component={item?.multiLanguage ? CheckIcon : CrossIcon} /> Multilingual Support</li>
                            </ul>
                          </div>

                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT: embedded checkout — sticky */}
          <div className="onboarding-right-panel" style={{
            flex: '1',
            position: 'sticky',
            top: 0,
            height: '100vh',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: (!checkoutLoading && clientSecret) ? 'flex-start' : 'center',
            padding: '40px',
            background: '#fff'
          }}>
            <div style={{ width: '100%', maxWidth: '480px' }}>
              {checkoutLoading && (
                <div style={{ textAlign: 'center', padding: '60px' }}>
                  <Spin size='large' tip='Preparing secure checkout...' />
                </div>
              )}
              {!checkoutLoading && clientSecret && (
                <div style={{
                  background: '#fff',
                  borderRadius: '12px',
                  minHeight: '400px'
                }}>
                  <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }} key={clientSecret}>
                    <EmbeddedCheckout />
                  </EmbeddedCheckoutProvider>
                </div>
              )}
              {!checkoutLoading && !clientSecret && (plans as any[]).length > 0 && (
                <div style={{ textAlign: 'center', color: '#888' }}>
                  <div style={{ fontSize: '48px', marginBottom: '16px' }}>💳</div>
                  <h3 style={{ color: '#1a1a1a', margin: '0 0 8px' }}>Secure Checkout</h3>
                  <p>Select a plan on the left to start your trial.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ✅ Skeleton Loader while data is fetching
  if (!planDetails || !plans || plans.length === 0) {
     return (
       <div className='planbills-wrapper'>
         <div className='current-plan'>
           <div className='plan-heading'>
             <div>
               <div style={{ width: '150px', height: '24px', backgroundColor: '#f0f0f0', borderRadius: '4px', marginBottom: '8px' }} />
               <div style={{ width: '250px', height: '16px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
             </div>
           </div>
           <div className='plan-includes'>
             {[1, 2, 3, 4].map(i => (
               <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                 <div style={{ width: '40%', height: '16px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
                 <div style={{ width: '20%', height: '16px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
               </div>
             ))}
           </div>
         </div>
         
         <div style={{ marginTop: '32px' }}>
           <div style={{ display: 'flex', gap: '20px', overflow: 'hidden' }}>
             {[1, 2, 3].map(i => (
               <div key={i} style={{ width: '300px', height: '400px', border: '1px solid #eee', borderRadius: '8px', padding: '24px' }}>
                 <div style={{ width: '100px', height: '24px', backgroundColor: '#f0f0f0', borderRadius: '4px', marginBottom: '16px' }} />
                 <div style={{ width: '80px', height: '32px', backgroundColor: '#f0f0f0', borderRadius: '4px', marginBottom: '24px' }} />
                 <div style={{ width: '100%', height: '40px', backgroundColor: '#f0f0f0', borderRadius: '4px', marginBottom: '24px' }} />
                 {[1, 2, 3, 4, 5].map(j => (
                   <div key={j} style={{ width: '100%', height: '16px', backgroundColor: '#f0f0f0', borderRadius: '4px', marginBottom: '12px' }} />
                 ))}
               </div>
             ))}
           </div>
         </div>
       </div>
     )
  }

  return (
    <div className='planbills-wrapper' style={isOnboarding ? { background: 'transparent', padding: '40px 20px', maxWidth: '1120px', margin: '0 auto' } : {}}>
      {!isOnboarding && (
        <>
          <h3>Current Plan</h3>
          <div className='current-plan'>
        <div className='plan-heading'>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
              <p className='plan-name' style={{ marginBottom: 0 }}>
                {planDetails?.name} {planDetails?.name !== 'Free' ? 'Plan' : ''}
              </p>
              {planDetails?.isTrial && (
                <span style={{
                  fontSize: '12px',
                  backgroundColor: 'rgba(255, 124, 2, 0.14)',
                  color: '#ff7c02',
                  padding: '4px 12px',
                  borderRadius: '16px',
                  fontWeight: 600,
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  border: '1px solid rgba(255, 124, 2, 0.3)'
                }}>
                  <Icon component={twinkle_icon} style={{ fontSize: '14px', color: '#ff7c02' }} />
                  7-Day Free Trial Active
                </span>
              )}
            </div>
            <p style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px', margin: 0 }}>
              You are currently on the {planDetails?.name} plan
              {planDetails?.isTrial && planDetails?.trialEndsAt ? (
                <span style={{
                  color: '#ff7c02',
                  fontWeight: 600,
                  backgroundColor: '#fff3e8',
                  padding: '2px 8px',
                  borderRadius: '6px'
                }}>
                  (Trial expires on {new Date(planDetails.trialEndsAt * 1000).toLocaleDateString()})
                </span>
              ) : null}
            </p>
          </div>
          {planDetails && planDetails?.name !== 'Agency' && <Button onClick={() => gotoPlans()}>Upgrade Plan</Button>}
        </div>
        <div className='plan-includes'>
          <div className='title'>
            <h4>What’s Included</h4>
            <h4>Price</h4>
          </div>
          <div className='plan-includes-table'>
            {planDetails?.details?.map((item: any) => {
              return (
                item.value != 0 && (
                  <div className='plan-include-row'>
                    <div className='row-left'>
                      <span>{item.name}</span>
                      <span>{item.value === true ? <CheckIcon /> : item.value}</span>
                    </div>
                    {item.price && <div className='row-right'>{item.price}</div>}
                  </div>
                )
              );
            })}
            <div className='plan-include-row'>
              <div className='row-left'>
                <span>Add Ons</span>
                <span>
                  <CheckIcon />
                </span>
              </div>
              <div className='row-right'></div>
            </div>
            <div className='plan-include-price'>
              <div className='row-left'>Monthly Total</div>
              {planDetails && <div className='row-right'>{planDetails.details?.[0]?.price}</div>}
            </div>
          </div>
        </div>
      </div>
    </>
  )}

      {!isOnboarding && (
        <div ref={planRef} id='plan-div'>
          <h3>Plans</h3>
        </div>
      )}

      {isOnboarding && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '40px' }}>
          <div style={{ textAlign: 'left' }}>
            <h1 style={{ fontSize: '36px', fontWeight: 600, color: '#333', marginBottom: '16px' }}>Start Your 7-Day Free Trial</h1>
            <p style={{ fontSize: '16px', color: '#666', maxWidth: '600px', margin: 0 }}>
              Select plan to start your free trial. Includes 5 blog generations. No charges today. Cancel anytime.
            </p>
          </div>
          <Button 
            onClick={handleLogout} 
            style={{ 
              marginTop: '8px',
              borderColor: '#ff7c02',
              color: '#ff7c02',
              borderRadius: '6px'
            }}
          >
            Sign Out
          </Button>
        </div>
      )}

      <div className='plan-details-container' style={isOnboarding ? { border: 'none', padding: 0 } : {}}>
        <div className='plans-content-wrapper'>
          <SideTitleInfo title='Subscription Plans' subTitle='Flexible pricing plans that fit your needs.'>
            {/* <div className='tab-content-wrapper'>
            {planTab?.map((plan: any) => (
              <Button
                key={plan?.id}
                className={`tab ${plan?.title.split('(')[0].toLowerCase() === planChoose ? 'active' : ''}`}
                onClick={() => handleTab(plan?.title)}
              >
                {plan?.title}
              </Button>
            ))}
          </div> */}
          </SideTitleInfo>
          <div className='plans-wrapper'>
            {plans.map((item: any, index) => (
              <div className='plan-item' key={index}>
                <div className={`content-wrapper ${(item.priceID === activePlanId || (isOnboarding && item?.name === 'Pro')) ? 'active' : ''}`}>
                  {item?.name === 'Pro' && (
                    <div className={`popular ${(item.priceID === activePlanId || (isOnboarding && item?.name === 'Pro')) ? 'active' : ''}`}>
                      <span role="img" aria-label="popular">🔥</span> Most Popular
                    </div>
                  )}
                  <div className={`plan-header  ${item.priceID === activePlanId ? 'active' : ''}`}>
                    <div className={`plan-title  ${item.priceID === activePlanId ? 'active' : ''}`}>{item?.name}</div>
                    <div className={`plan-price  ${item.priceID === activePlanId ? 'active' : ''}`}>
                      {/* {item?.price && ( */}
                      <div className={`price  ${item.priceID === activePlanId ? 'active' : ''}`}>
                        ${item?.price}
                        {/* {item?.price && ( */}
                        <span className='billed'>&nbsp; / &nbsp; mo</span>
                        {/* )} */}
                        {/* {item?.discount !== '0' && <span className='discount'>Get {item?.discount}% off</span>} */}
                      </div>
                      {/* )} */}
                    </div>
                  </div>
                  {isOnboarding ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '20px', marginBottom: '20px', padding: '0 20px' }}>
                      <Button
                        type="primary"
                        ghost
                        size="large"
                        loading={loading[index]}
                        onClick={async () => {
                          setLoading((prev: any) => ({ ...prev, [index]: true }));
                          try {
                            const body = { userId, priceId: item.priceID };
                            const res = await axios.post(`${process.env.REACT_APP_SERVER_URL}/trial/checkout-session`, body, {
                              headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                            });
                            if (res.data?.checkoutUrl) {
                              window.location.href = res.data.checkoutUrl;
                            } else {
                              message.error('Could not get checkout URL');
                              setLoading((prev: any) => ({ ...prev, [index]: false }));
                            }
                          } catch (error: any) {
                            console.log(error);
                            const msg = error.response?.data?.message || 'Something went wrong. Please, try again.';
                            message.error({ content: msg, key: 'trial-start-wrong' });
                            setLoading((prev: any) => ({ ...prev, [index]: false }));
                          }
                        }}
                        style={{ 
                          width: '100%', 
                          borderRadius: '8px', 
                          height: '44px', 
                          fontWeight: 600,
                          backgroundColor: (isOnboarding && item?.name === 'Pro') ? '#fff' : 'transparent',
                          borderColor: (isOnboarding && item?.name === 'Pro') ? '#fff' : '#ff7c02',
                          color: '#ff7c02'
                        }}
                      >
                        Start Free Trial
                      </Button>
                      
                      {/* <Button
                        type="primary"
                        size="large"
                        onClick={() => navigate(`/plan-checkout?planId=${item.priceID}`)}
                        style={{ 
                          width: '100%', 
                          borderRadius: '8px', 
                          height: '44px', 
                          fontWeight: 600,
                          backgroundColor: '#fff',
                          color: '#ff7c02',
                          boxShadow: 'none',
                          border: 'none'
                        }}
                      >
                        Buy Now
                      </Button> */}
                    </div>
                  ) : (
                    <Button
                      onClick={async () => {
                        if (item.priceID === activePlanId) {
                          message.error('You are already on this plan.');
                          return;
                        }

                        /// upgrading only if user is on low plan

                        axios

                          .get(
                            `${process.env.REACT_APP_SERVER_URL}/can-upgrade?planName=${item.name}&userId=${userId}`,

                            {
                              headers: {
                                Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                              }
                            }
                          )

                          .then(async (res) => {
                            if (res.data.canUpgrade) {
                              /// directly ugrade the subscription without collecting card details user already had default payment method set

                              const hasPaymentMethod = await checkUserPaymentMethod();

                              if (hasPaymentMethod) {
                                navigate(`/plan-checkout?planId=${item.priceID}&source=plan-upgrade&addCard=false`);
                              } else {
                                navigate(`/plan-checkout?planId=${item.priceID}&source=plan-upgrade&addCard=true`);
                              }
                            } else {
                              /// donwgrade the plan if user is on higher plan

                              setIsDowngradeModelVisible(true);
                              setDownPriceId(item?.priceID);
                              setDownPriceName(item?.name);
                              return;
                            }
                          })

                          .catch((error) => {
                            message.error({
                              content: 'Unable to fetch plan details. Please, try again later.',
                              key: 'unable-to-fetch-plan'
                            });
                          });
                      }}
                      className={`${item?.name === downgradePlanName
                        ? 'downgrade-btn'
                        : item.priceID === activePlanId
                          ? 'active-btn'
                          : ''
                        }`}
                      loading={loading[index]}
                      disabled={activePlanId ? item.priceID === activePlanId || item?.name === downgradePlanName : true}
                    >
                      {index == activeIndex
                        ? 'Current Plan'
                        : index < activeIndex
                          ? item?.name === downgradePlanName
                            ? `Downgrade Scheduled`
                            : `Downgrade`
                          : `Upgrade`}
                    </Button>
                  )}
                  <div className={`plan-content  ${item.priceID === activePlanId ? 'active' : ''}`}>
                    <span className={`title  ${item.priceID === activePlanId ? 'active' : ''}`}>LLM Models</span>
                    <ul>
                      {models?.map((cont: string) => {
                        return item?.llmModels?.includes(cont) ? (
                          <li key={cont}>
                            <Icon component={CheckIcon} /> {modelNames[cont] || cont}
                          </li>
                        ) : (
                          <li key={cont} className=''>
                            <Icon  component={CrossIcon} />
                            {modelNames[cont] || cont}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  <div className={`plan-content  ${item.priceID === activePlanId ? 'active' : ''}`}>
                    <span className={`title  ${item.priceID === activePlanId ? 'active' : ''}`}>What's included?</span>
                    <ul>
                      <li className={`${item?.blogCount ? '' : ''} `}>
                        <Icon component={item?.blogCount ? CheckIcon : CrossIcon} /> {item?.blogCount + ' Blog Generations'}
                      </li>
                      <li>
                        <Icon component={item?.blogAuditCount ? CheckIcon : CrossIcon} /> {(item?.blogAuditCount ?? item?.blogCount) + ' Blog Auditor Credits'}
                      </li>
                      <li>
                        <Icon component={item?.aeoScanCount ? CheckIcon : CrossIcon} /> {(item?.aeoScanCount ?? item?.blogCount) + ' AEO Scan Credits'}
                      </li>
                      <li className={`${item?.fileCount !== undefined ? '' : ''} `}>
                        <Icon component={item?.fileCount ? CheckIcon : CrossIcon} /> {item?.fileCount + ' Files / Blog'}
                      </li>
                      <li className={`${item?.keywordResearch ? '' : ''} `}>
                        <Icon component={item?.keywordResearch ? CheckIcon : CrossIcon} /> {'Key Word Research'}
                      </li>

                      <li className={`${item?.linkCount > 0 ? '' : ''} `}>
                        <Icon component={item?.linkCount > 0 ? CheckIcon : CrossIcon} /> {item?.linkCount + ' Link Crawl / Blog'}
                      </li>
                      <li className={`${item?.multiLanguage ? '' : ''} `}>
                        <Icon component={item?.multiLanguage ? CheckIcon : CrossIcon} /> {'Multilingual Support'}
                      </li>
                      <li className={`${item?.aiImageGeneration ? '' : ''} `}>
                        <Icon component={item?.aiImageGeneration ? CheckIcon : CrossIcon} /> {'AI Image Generation'}
                      </li>

                      {/* {planDetail[2].content?.map((cont) => (
                      <li
                        className={`${cont?.disabled ? "disabled" : ""} ${
                          item.title
                        }`}
                        key={cont?.text}
                      >
                        <Icon component={CheckIcon} /> {cont?.text}
                      </li>
                    ))} */}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      {!isOnboarding && (
        <>
          {/* <h3>Add Ons</h3> */}
          <div className='addOns-content-wrapper'>
            <SideTitleInfo
              title={
                <div>
                  One Time Add-On <span>(Buy When Need)</span>
                </div>
              }
            // subTitle="Flexible pricing plans that fit your needs."
            ></SideTitleInfo>
            <div className='addOns-wrapper'>
              <div className='addOns-Grid'>
                <div className='addOns-item'>
                  <div className='addOns-head'>
                    <div className='addOns-name'>Blog Generations</div>
                    <div className='addOns-name'>${blogPrice}</div>
                  </div>
                  <div className='addOns-body'>
                    {planDetails && (
                      <span>{blogPrice} Blogs</span>
                    )}
                  </div>
                  <Slider
                    marks={blogMarks}
                    step={null}
                    defaultValue={0}
                    tooltip={{ open: false }}
                    onChange={(value) => addOnBlogCount(value)}
                  />
                  <div className='total-addOn' style={{ marginTop: '12px' }}>
                    <div>
                      Total: <span>${totalPrice}</span>
                    </div>
                    <Tooltip title={planDetails?.isTrial ? 'Add-ons are unavailable during your free trial' : ''} placement='top'>
                      <button
                        onClick={purchaseAddOn}
                        disabled={!!planDetails?.isTrial}
                        style={planDetails?.isTrial ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                      >
                        Purchase
                      </button>
                    </Tooltip>
                  </div>
                </div>

                <div className='addOns-item'>
                  <div className='addOns-head'>
                    <div className='addOns-name'>Blog Auditor Credits</div>
                    <div className='addOns-name'>${auditPrice.toFixed(2)}</div>
                  </div>
                  <div className='addOns-body'>
                    {planDetails && (
                      <span>{auditQty} Audits</span>
                    )}
                  </div>
                  <Slider
                    marks={auditMarks}
                    step={null}
                    defaultValue={0}
                    tooltip={{ open: false }}
                    onChange={(value) => setAuditAddOn(value)}
                  />
                  <div className='total-addOn' style={{ marginTop: '12px' }}>
                    <div>
                      Total: <span>${auditPrice.toFixed(2)}</span>
                    </div>
                    <Tooltip title={planDetails?.isTrial ? 'Add-ons are unavailable during your free trial' : ''} placement='top'>
                      <button
                        onClick={purchaseAuditAddOn}
                        disabled={!!planDetails?.isTrial}
                        style={planDetails?.isTrial ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                      >
                        Purchase
                      </button>
                    </Tooltip>
                  </div>
                </div>

                <div className='addOns-item'>
                  <div className='addOns-head'>
                    <div className='addOns-name'>AEO Scan Credits</div>
                    <div className='addOns-name'>${aeoPrice.toFixed(2)}</div>
                  </div>
                  <div className='addOns-body'>
                    {planDetails && (
                      <span>{aeoQty} Scans</span>
                    )}
                  </div>
                  <Slider
                    marks={aeoMarks}
                    step={null}
                    defaultValue={0}
                    tooltip={{ open: false }}
                    onChange={(value) => setAeoAddOn(value)}
                  />
                  <div className='total-addOn' style={{ marginTop: '12px' }}>
                    <div>
                      Total: <span>${aeoPrice.toFixed(2)}</span>
                    </div>
                    <Tooltip title={planDetails?.isTrial ? 'Add-ons are unavailable during your free trial' : ''} placement='top'>
                      <button
                        onClick={purchaseAeoAddOn}
                        disabled={!!planDetails?.isTrial}
                        style={planDetails?.isTrial ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                      >
                        Purchase
                      </button>
                    </Tooltip>
                  </div>
                </div>

              </div>
              <span className='price-summary' onClick={() => setIsModalOpen(true)}>
                See Price Summary
              </span>
            </div>
          </div>
        </>
      )}
      </div>

      {!isOnboarding && (
        <>
          {/* show this container only has not cancelled his plan */}
          {planDetails?.hasSubscription && (
            <>
              <h3>Plan Cancellation</h3>
              <div className='plan-cancel-container'>
                {planDetails?.cancellationDate ? (
                  // ✅ Already cancelled — show date + resume option
                  <>
                    <div className='plan-cancel'>
                      Your plan will be cancelled on{' '}
                      <strong>
                        {new Date(planDetails.cancellationDate * 1000).toLocaleDateString()}
                      </strong>
                      . You'll keep access until then.
                    </div>
                    <button
                      onClick={() => {
                        axios
                          .get(`${process.env.REACT_APP_SERVER_URL}/reactivate-subscription?userId=${userId}`, {
                            headers: {
                              Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                            }
                          })
                          .then(() => {
                            message.success({ content: 'Plan reactivated successfully', key: 'reactivate-success' });
                            window.location.reload();
                          })
                          .catch(() => {
                            message.error({ content: 'Unable to reactivate plan. Please try again.', key: 'reactivate-error' });
                          });
                      }}
                    >
                      Resume Plan
                    </button>
                  </>
                ) : planDetails?.downgradeScheduleDate ? (
                  // ✅ Downgrade scheduled — show date + resume current plan option
                  <>
                    <div className='plan-cancel'>
                      You will be moved to the <strong>{planDetails.downgradePlan}</strong> plan on{' '}
                      <strong>{new Date(planDetails.downgradeScheduleDate * 1000).toLocaleDateString()}</strong>.
                    </div>
                    <button
                      onClick={() => {
                        axios
                          .get(`${process.env.REACT_APP_SERVER_URL}/resume-subscription?userId=${userId}`, {
                            headers: {
                              Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                            }
                          })
                          .then(() => {
                            message.success({ content: 'Downgrade cancelled successfully', key: 'resume-success' });
                            window.location.reload();
                          })
                          .catch(() => {
                            message.error({ content: 'Unable to resume plan. Please try again.', key: 'resume-error' });
                          });
                      }}
                    >
                      Resume Current Plan
                    </button>
                  </>
                ) : (
                  // ✅ Active — show cancel option (opens modal)
                  <>
                    <div className='plan-cancel'>
                      You'll keep access to your workspace through the end of {planDetails?.isTrial ? 'your 7-day trial' : 'the month'}.
                    </div>
                    <button
                      onClick={() => {
                        setShowCancelModal(true);
                      }}
                    >
                      Cancel
                    </button>
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}
      <PlanCancellationModal
        isVisible={showCancelModal}
        onClose={() => setShowCancelModal(false)}
        onConfirm={handleCancelPlan}
      />
      <DowngradePlanModal
        isDowngradeModelVisible={isDowngradeModelVisible}
        setIsDowngradeModelVisible={setIsDowngradeModelVisible}
        priceId={downPriceId}
        downgradePlanName={downPriceName}
        planDetails={planDetails}
        downPlan={downPlan}
      />
      <Modal
        centered
        className='keyword-model'
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        closable={false}
      >
        <PriceSummary
          addOnDetails={[
            ...addOnDetails,
            { name: 'Blog Auditor Credits', value: auditQty, price: auditPrice },
            { name: 'AEO Scan Credits', value: aeoQty, price: aeoPrice }
          ]}
          totalPrice={(Number(totalPrice) + Number(auditPrice) + Number(aeoPrice)).toFixed(2)}
          setIsModalOpen={setIsModalOpen}
        />
      </Modal>
    </div>
  );
};

export default PlanBills;
